// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
      position: relative;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
    padding-top: 20px;
    padding-bottom: 20px;
    }

  .footer h5 {
    margin-bottom: 15px;
    font-weight: bold;
  }
  
  .footer p,
  .footer ul {
    margin-bottom: 10px;
  }
  
  .footer ul {
    padding-left: 0;
    list-style: none;
  }
  
  .footer ul li {
    margin-bottom: 5px;
  }
  
  .footer .text-center {
    text-align: center;
  }
  
  @media (max-width: 768px) {
    .footer .col-md-4 {
      text-align: center;
      margin-bottom: 20px;
    }
  
    .footer p {
      width: 50%;
    }
  }`, "",{"version":3,"sources":["webpack://./src/css/Footer.css"],"names":[],"mappings":"AAAA;MACM,kBAAkB;MAClB,SAAS;MACT,OAAO;MACP,QAAQ;MACR,WAAW;IACb,iBAAiB;IACjB,oBAAoB;IACpB;;EAEF;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE;MACE,kBAAkB;MAClB,mBAAmB;IACrB;;IAEA;MACE,UAAU;IACZ;EACF","sourcesContent":["footer {\r\n      position: relative;\r\n      bottom: 0;\r\n      left: 0;\r\n      right: 0;\r\n      width: 100%;\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n    }\r\n\r\n  .footer h5 {\r\n    margin-bottom: 15px;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .footer p,\r\n  .footer ul {\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .footer ul {\r\n    padding-left: 0;\r\n    list-style: none;\r\n  }\r\n  \r\n  .footer ul li {\r\n    margin-bottom: 5px;\r\n  }\r\n  \r\n  .footer .text-center {\r\n    text-align: center;\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    .footer .col-md-4 {\r\n      text-align: center;\r\n      margin-bottom: 20px;\r\n    }\r\n  \r\n    .footer p {\r\n      width: 50%;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
